import { TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY } from '@monorepo/types';
import { TLiftedFormModel } from '../../model/form.model';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { PIPELINE_FORM } from '../../model/form.pipeline';

export const BULK_EDIT_PRODUCT_LINE_EFFICIENCY_FORM_MODEL = {
  createModel: <T>(
    allocatedProductTypes: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY['allocatedProductTypes'],
  ): TLiftedFormModel<T> => {
    return PIPELINE_FORM.sanitize<T>({
      inputs: allocatedProductTypes.map((product) => ({
        input: {
          type: 'INPUT',
          subType: 'number',
          min: 0,
        },
        metadata: {
          keyName: product.id,
          label: product.name,
        },
      })),
      isValid: false,
    });
  },

  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};
